/**
 * Negativação manual do cliente (feature `001-negativacao-cliente` do
 * personservice).
 *
 * Duas fronteiras que a interface tem de respeitar na linguagem que usa:
 * não é negativação em Serasa/SPC (nada é comunicado a órgão nenhum) e não
 * bloqueia nada (não suspende contrato, não impede acesso, não altera conta a
 * receber). É informação interna para a equipe.
 */

/** Ações registradas no histórico. Enum numérico 1:1 com `NegativationAction` do backend. */
export enum ENegativationAction {
  Negativated = 1,
  NoteChanged = 2,
  Removed = 3,
}

/**
 * Situação atual da marcação. O backend devolve este mesmo shape para cliente
 * nunca marcado — `IsNegativated: false` com o resto nulo, sem 404.
 */
export type TPersonNegativation = {
  PersonId: string;
  IsNegativated: boolean;
  Note: string | null;
  NegativatedOnUtc: string | null;
  NegativatedBy: string | null;
  /** Resolvido no servidor a partir do id; o cliente não informa. */
  NegativatedByName: string | null;
};

/**
 * Uma alteração da marcação. O histórico é append-only, sobrevive à remoção e
 * nunca é sobrescrito.
 */
export type TPersonNegativationHistory = {
  PersonNegativationHistoryId: string;
  PersonId: string;
  Action: ENegativationAction;
  /** A observação informada nesta alteração, não a vigente. */
  Note: string | null;
  PreviousState: boolean;
  NewState: boolean;
  EventOnUtc: string | null;
  EventBy: string | null;
  EventByName: string | null;
};

/** Entrada da ativação e da alteração da observação. Sem campo de usuário: a autoria vem da sessão. */
export type TPersonNegativationRequest = {
  Note: string | null;
};

/** Rótulo i18n de cada ação do histórico. */
export const negativationActionLabels: Record<ENegativationAction, string> = {
  [ENegativationAction.Negativated]:
    'PROFILE.NEGATIVATION.HISTORY.ACTION.NEGATIVATED',
  [ENegativationAction.NoteChanged]:
    'PROFILE.NEGATIVATION.HISTORY.ACTION.NOTE_CHANGED',
  [ENegativationAction.Removed]: 'PROFILE.NEGATIVATION.HISTORY.ACTION.REMOVED',
};
